import { useRouter } from 'next/navigation';
import { useQueryState } from 'nuqs';

import { Modal } from '../../components/Modal/Modal';
import { Redirect } from '../../components/Redirect/Redirect';
import { reportMykissClientError } from '../../helpers/errorHandling/client';
import { useCurrentURL } from '../../helpers/hooks/useCurrentURL/useCurrentURL';

import { URLParameters } from './constants/url/urlParameters';
import { getCompany } from './helpers/company/getCompany';
import { getModalCloseButtonAvailability } from './helpers/modal/getModalCloseButtonAvailability';

export const Onboarding = () => {
  const { replace } = useRouter();
  const { removeParameters } = useCurrentURL();
  const fallbackURL = removeParameters([URLParameters.Company, URLParameters.Flow]);
  const [companyParam] = useQueryState(URLParameters.Company);
  const [flowParam] = useQueryState(URLParameters.Flow);
  const Company = getCompany(companyParam);
  const isCloseButtonDisabled = getModalCloseButtonAvailability(companyParam, flowParam);

  const handleClose = async (): Promise<void> => {
    const clearedURL = removeParameters([URLParameters.Company, URLParameters.Flow]);
    try {
      replace(clearedURL);
    } catch (error) {
      reportMykissClientError(error);
    }
  };

  // companyParam exists in URL but doesnt match any company
  if (companyParam !== null && !Company) {
    return <Redirect to={fallbackURL} />;
  }

  return Company ? (
    <Modal
      disableClose={isCloseButtonDisabled}
      isOpen
      onClose={handleClose}
      outerClassName="z-modal-flow"
      size="full"
      style={{ minWidth: '100vw' }}
    >
      <Company />
    </Modal>
  ) : (
    <></>
  );
};
